import { render, staticRenderFns } from "./NurseCreate.vue?vue&type=template&id=8c0c5144&"
import script from "./NurseCreate.vue?vue&type=script&lang=js&"
export * from "./NurseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports